export function getDaysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

export function getFirstDayOfMonth(year, month) {
    return new Date(year, month, 1).getDay();
}

export function getWeekDays(selectedDate) {
    const d = new Date(selectedDate);
    const days = [];

    for (let i = -3; i <= 3; i++) {
        const dd = new Date(d);
        dd.setDate(d.getDate() + i);
        days.push(dd);
    }

    return days;
}

export function getEntireMonth(selectedDate) {
    const d = new Date(selectedDate);
    const month = d.getMonth();
    const year = d.getFullYear();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDay = getFirstDayOfMonth(year, month);
    const days = [];
    // for (let i = 0; i < firstDay; i++) days.push(null);
    for (let d = 1; d <= daysInMonth; d++) {
        const newDate = new Date(year, month, d);
        days.push(newDate);
    }
    return days;
}

export function formatKey(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}